<template>
  <v-btn
    class="navbarButton admin v-step-2"
    name="action"
    :disabled="!btnState"
    @click="redirect"
    :key="$route.path"
  >
    <v-icon>group</v-icon>
    Admin
  </v-btn>
</template>
<script>
import router from '@/router';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      myInterval: undefined,
    };
  },
  computed: {
    ...mapGetters({
      btnState: 'btnAdminValue',
    }),
  },
  methods: {
    redirect() {
      router.push({ path: '/admin' });
      router.go();
    },
  },
};
</script>

<style scoped lang="scss">
.navbarButton {
  &.admin {
    margin-left: 10px;
  }
}
</style>
